module.exports = __webpack_public_path__ + "img/baotofu.5aa3aa6f.jpg";